import { createNewChat } from 'actions/supportAssistant/supportAssistantActions'
import Modal from 'components/Luxkit/Modal/Modal'
import BodyText from 'components/Luxkit/Typography/BodyText'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { useAppDispatch } from 'hooks/reduxHooks'
import React from 'react'

export interface NewChatModalResult {
  triggerLogin: boolean
}

function NewChatModal() {
  const dispatch = useAppDispatch()

  const modalElement = useModalElementContext<NewChatModalResult>()

  const onLoginToSaveClick = () => {
    modalElement.resolve({ triggerLogin: true })
  }

  const onContinueWithoutSavingClick = () => {
    dispatch(createNewChat())
    modalElement.resolve({ triggerLogin: false })
  }

  return (
    <Modal
      title="Would you like to save the current chat?"
      primaryActionText="Login to save chat"
      secondaryActionText="Continue without saving"
      onPrimaryActionClick={onLoginToSaveClick}
      onSecondaryActionClick={onContinueWithoutSavingClick}
    >
      <BodyText variant="large">
        Login to your Luxury Escapes account to save your chats with LESA and access anytime to continue where you left off.
      </BodyText>
    </Modal>
  )
}

export default NewChatModal
